import type { ReserveContextType } from '../../contexts/useReserveContext';

export type ReserveStoreOption = {
  id: number;
  name: string;
};

type StoreSelectionActions = Pick<
  ReserveContextType,
  | 'setStoreId'
  | 'setStoreName'
  | 'setSelectedServices'
  | 'setSelectedDate'
  | 'setSelectedStartTime'
  | 'setSelectedStaffId'
  | 'setSelectedStaffName'
  | 'setIsFreeReservation'
>;

export const applySelectedStore = (
  actions: StoreSelectionActions,
  store: ReserveStoreOption,
) => {
  actions.setStoreId(store.id);
  actions.setStoreName(store.name);
  actions.setSelectedServices([]);
  actions.setSelectedDate(null);
  actions.setSelectedStartTime(null);
  actions.setSelectedStaffId(null);
  actions.setSelectedStaffName(null);
  actions.setIsFreeReservation(false);
};
